import { useEffect, useState } from "react";
import { api } from "@/lib/api";

// V4.6 (NOTIF-151): dealer Reports badge — authorized unseen status updates.
export function useUnseenReports() {
  const [unseen, setUnseen] = useState(0);

  useEffect(() => {
    let cancelled = false;
    const fetchUnseen = () =>
      api
        .get("/reports/unseen-count")
        .then((res) => !cancelled && setUnseen(res.data.unseen))
        .catch(() => {});
    fetchUnseen();
    const t = setInterval(fetchUnseen, 30000);
    const onChanged = () => fetchUnseen();
    window.addEventListener("notifications:changed", onChanged);
    return () => {
      cancelled = true;
      clearInterval(t);
      window.removeEventListener("notifications:changed", onChanged);
    };
  }, []);

  return unseen;
}
